import { ThemeContext } from '@shared/store/context/ThemeContext';
import { useContext } from 'react';

export const useThemeContext = () => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error("Can't user ThemeContext outside ThemeContextProvider");
  }

  return context;
};
